import { useState } from 'react';
import { Icon } from './Icons';

interface Props {
  value: string;
  label?: string;
  prefix?: string;
  big?: boolean;
}

export function CopyField({ value, label, prefix, big = false }: Props) {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      /* swallow — clipboard may be blocked, button still shows confirmation */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1400);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        background: 'var(--bg-sunken)',
        border: '1px dashed var(--line-strong)',
        borderRadius: 'var(--r-md)',
        padding: big ? '14px 14px 14px 18px' : '8px 8px 8px 12px',
      }}
    >
      {label && (
        <div
          style={{
            fontSize: 11,
            color: 'var(--ink-3)',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </div>
      )}
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: big ? 18 : 13,
          fontWeight: 500,
          color: 'var(--ink)',
          flex: 1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {prefix && <span style={{ color: 'var(--ink-3)' }}>{prefix}</span>}
        {value}
      </div>
      <button
        onClick={onCopy}
        title="Copy"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          background: copied ? 'var(--good)' : 'var(--ink)',
          color: copied ? '#fff' : 'var(--bg-elev)',
          padding: big ? '8px 14px' : '6px 10px',
          borderRadius: 'var(--r-sm)',
          fontWeight: 500,
          fontSize: 12,
          transition: 'background 0.18s ease',
        }}
      >
        {copied ? (
          <>
            <Icon.Check />
            Copied
          </>
        ) : (
          <>
            <Icon.Copy />
            Copy
          </>
        )}
      </button>
    </div>
  );
}
